let linkConfig = {
	download: {
		ios: {
			eetrade: "https://apps.apple.com/cn/app/%E5%8D%97%E5%8D%8E%E9%87%91%E4%B8%9A/id6477434010",
			eetmarkets: "https://apps.apple.com/cn/app/%E5%8D%97%E5%8D%8E%E9%87%91%E4%B8%9A/id6477434010",
		},
		androidUrl: {
			eetall: "https://downloads.btgwxz8.com/source/material/EET_GW.apk",
			eetrade: "https://downloads.gwappxz6.com/source/material/hbbhkj_seo_eet_appid=771.apk",
			eetmarkets: "https://downloads.gwappxz6.com/source/material/eetradehk_seo_eet_appid=772.apk",
		},
	},
};

export { linkConfig };
